import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ProjectSearchPipe', pure: false })
export class ProjectSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(project => {
        if (project.jobId) {
          if (project.jobId.search(searchText) !== -1 || project.description.search(searchText) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
    return [];
  }
}
